import React, { useState } from 'react'
import { Box, Button, Container, TextField, Typography } from '@mui/material'
import { useNavigate } from "react-router-dom"
import { useUserContext } from 'strview-common'

const NewPasswordForm = () => {
  const { completeNewPasswordChallenge } = useUserContext()
  const navigate = useNavigate()
  const [errorMessage, setErrorMessage] = useState("")

  const handleSubmit = async (event) => {
    event.preventDefault()
    const formData = new FormData(event.currentTarget)
    const data = {
      email: formData.get("email"),
      password: formData.get("password"),
      newPassword: formData.get("newPassword"),
    }
    const completeNewPasswordChallengeResult = await completeNewPasswordChallenge(data)
    if (completeNewPasswordChallengeResult.success) {
      navigate("/")
    } else {
      setErrorMessage(completeNewPasswordChallengeResult.errorMessage)
    }
  }

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography component="h1" variant="h5">
          First Time Login - Change Password
        </Typography>
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="newPassword"
            label="New Password"
            type="password"
            id="newPassword"
            autoComplete="new-password"
          />
          {/* <FormControlLabel
                control={<Checkbox value="remember" color="primary" />}
                label="Remember me"
              /> */}
          <Typography sx={{ "color": "red" }} >
            {errorMessage}
          </Typography>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            Sign In
          </Button>
        </Box>
      </Box>
    </Container>
  )
}

export default NewPasswordForm